import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import ServiceFeedingTheNeedy from '../../components/ServiceFeedingTheNeedy'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'


const ServiceFeedingTheNeedyPage =() => {
    return(
        <Fragment>
            <Navbar/>
            <PageTitle pageTitle={'Service'} pagesub={'Service'}/>
            <ServiceFeedingTheNeedy/>
            <Footer footerClass={'wpo-ne-footer-2'}/>
            <Scrollbar/>
        </Fragment>
    )
};
export default ServiceFeedingTheNeedyPage;
